import { AuthMethod } from './types';

const KEY = 'pending_auth_v1';
const TTL_MS = 15 * 60 * 1000;

export type PendingAuth = {
  method: AuthMethod;
  identifier: string;
  session: string;
  startedAt: number;
  expiresAt: number;
};

export function setPendingAuth(data: Omit<PendingAuth, 'startedAt' | 'expiresAt'>): void {
  if (typeof window === 'undefined') return;
  const now = Date.now();
  const payload: PendingAuth = { ...data, startedAt: now, expiresAt: now + TTL_MS };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    // localStorage indisponível (modo anônimo restrito, quota) — silenciar
  }
}

export function getPendingAuth(): PendingAuth | null {
  if (typeof window === 'undefined') return null;
  let raw: string | null;
  try {
    raw = window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
  if (!raw) return null;

  let parsed: PendingAuth;
  try {
    parsed = JSON.parse(raw) as PendingAuth;
  } catch {
    clearPendingAuth();
    return null;
  }

  if (
    !parsed ||
    typeof parsed.method !== 'string' ||
    typeof parsed.identifier !== 'string' ||
    typeof parsed.session !== 'string' ||
    typeof parsed.expiresAt !== 'number'
  ) {
    clearPendingAuth();
    return null;
  }

  if (Date.now() > parsed.expiresAt) {
    clearPendingAuth();
    return null;
  }

  return parsed;
}

export function clearPendingAuth(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // noop
  }
}
